import { APP_CONFIG } from '../../../services/app-config'
import { axiosFactory } from './axiosFactory'

export const axiosBasic = axiosFactory.getAxios('basic', {
  headers: {
    Authorization: `Basic ${APP_CONFIG.basicToken}`,
  },
})
